import styled from 'styled-components';
import { FormText } from './TypoStyle';

export const ComboModalErrorMessage = styled(FormText)`
  margin-top: 16px;
  text-align: center;
`;

export const ComboModalErrorContainer = styled.div`
  padding-top: 44px;
  flex-direction: column;
  flex: 1;
  align-items: center;
  align-self: stretch;
  z-index: 9;
  display: ${(props: { showError: boolean }) => (props.showError ? 'flex' : 'none')};
  #spinner {
    display: ${(props: { showError: boolean }) => (props.showError ? 'none' : 'flex')};
  }
`;
